import { StyleSheet } from 'react-native';
import { STYLE_VARS } from '../../../../../constants/style-vars';

const styles = StyleSheet.create({
  wrapper: {
    paddingVertical: 30,
    flex: 1,
  },

  nameSectionText: {
    fontSize: 22,
    letterSpacing: 2,
    textTransform: 'uppercase',
    color: STYLE_VARS.primaryColor,
    fontFamily: STYLE_VARS.iowanOldStyleFont,
    textAlign: 'center',
  },
  contentContainer: {
    paddingVertical: 30,
    flexGrow: 1,
    flex: 1,
    flexDirection: 'column',
    width: '100%',
    height: 400,
  },
  content: {},

  showAllText: {
    fontSize: 14,
    letterSpacing: 2,
    textTransform: 'uppercase',
    color: STYLE_VARS.primaryColor,
    textDecorationLine: 'underline',
    fontFamily: STYLE_VARS.avenirMediumFont,
    textAlign: 'center',
  },
});
export default styles;
